export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7870.5433e84b.jpg";